// src/utils/guidaOnline.js
// ═══════════════════════════════════════════════════════════════════════════
// CENTRO ASSISTENZA SUL SITO (ottobre 2026)
// La guida passo passo vive su nexiora.it/guida/ e si apre SEMPRE in una nuova scheda del
// browser: niente pagine del sito dentro l'app. Qui solo la corrispondenza
// «pagina (o scheda della commessa) → scheda della guida». Se una pagina non ha una scheda
// sua si apre l'indice del Centro assistenza.
// Gli id delle schede sono quelli di demo/guida/schede.py (sito): se se ne aggiunge una,
// basta aggiungere qui la riga.
// ═══════════════════════════════════════════════════════════════════════════

export const URL_CENTRO_ASSISTENZA = "https://nexiora.it/guida/";

const PER_PAGINA = {
  "home": "home",
  "le-mie-commesse": "le-mie-commesse",
  "control-center": "centro-operativo",
  "clienti": "clienti",
  "registro-commesse": "commessa",
  "presenze": "presenze",
  "approvazione-cartellini": "presenze",
  "nota-spese": "nota-spese",
  "approvazione-note-spese": "nota-spese",
  "richiesta-ferie": "ferie-permessi",
  "approvazione-ferie-permessi": "ferie-permessi",
  "programmazione": "programmazione",
  "registro-sopralluoghi": "sopralluogo",
  "sopralluoghi-senza-commessa": "sopralluogo",
  "segnalazioni-cliente": "segnalazioni-cliente",
  "registro-segnalazioni": "segnalazioni-cliente",
  "registro-rapportini": "rapportini",
  "registro-note": "registro-note",
  "le-mie-ore": "le-mie-ore",
  "le-mie-bozze": "le-mie-bozze",
  "ditte-esterne": "ditte-esterne",
  "registro-ddt": "ddt",
  "registro-ddt-ingresso": "ddt-ingresso",
  "registro-interventi": "registro-interventi",
  "registro-corrispondenza": "corrispondenza",
  "pratiche-aperte": "pratiche",
  "registro-sal": "sal",
  "elaborazione-offerte": "offerte",
  "da-fatturare": "da-fatturare",
  "ordini-materiali": "richieste-materiale",
  "richiedi-nf": "nf-oda",
  "centro-acquisti": "nf-oda",
  "magazzino": "magazzino",
  "rientro-materiali": "rientro-materiali",
  "registro-rientri-materiali": "rientro-materiali",
  "registro-noleggi": "noleggi",
  "parco-mezzi": "parco-mezzi",
  "disponibilita-mezzi": "parco-mezzi",
  "gestione-contratti-manutenzione": "contratti-manutenzione",
  "contratti-manutenzione": "contratti-manutenzione",
  "impianti": "impianti",
  "scadenziario": "scadenzario",
  "documenti-subappaltatori": "subappaltatori",
  "nexiora-insight": "insight",
  "strumenti-tecnici": "strumenti-tecnici",
  "impostazioni-org": "impostazioni-aziendali",
  "users": "utenti",
  "abilitazioni": "abilitazioni",
  "dipendenti": "dipendenti",
};

// Schede dentro la commessa (activeTab di ProjectView)
const PER_SCHEDA_COMMESSA = {
  "list": "commessa", "board": "commessa", "calendar": "commessa", "dashboard": "commessa", "membri": "commessa",
  "cabina-regia": "cabina-regia",
  "rapportini": "rapportini",
  "sopralluogo": "sopralluogo",
  "giornale": "giornale-cantiere",
  "sicurezza": "sicurezza",
  "ddt": "ddt",
  "ddt-ingresso": "ddt-ingresso",
  "registro-interventi": "registro-interventi",
  "comunicazioni": "corrispondenza",
  "pratiche": "pratiche",
  "report": "report-commessa",
  "cronoprogramma": "cronoprogramma", "gantt": "cronoprogramma",
  "economico": "controllo-economico",
  "extra": "varianti",
  "sal": "sal",
  "materiali": "richieste-materiale",
  "richiedi-nf": "nf-oda",
  "manutenzione": "manutenzione-capitolato",
};

export function schedaGuida(pagina, schedaCommessa) {
  if (pagina === "project") return PER_SCHEDA_COMMESSA[schedaCommessa] || "commessa";
  return PER_PAGINA[pagina] || null;
}

// Come sopra ma senza ripiego: null se la pagina non ha una scheda sua (per i link «Come si fa»)
export function schedaGuidaEsatta(pagina, schedaCommessa) {
  if (pagina === "project") return PER_SCHEDA_COMMESSA[schedaCommessa] || null;
  return PER_PAGINA[pagina] || null;
}

export const urlScheda = id => `${URL_CENTRO_ASSISTENZA}${id}.html`;

export function urlGuida(pagina, schedaCommessa) {
  const id = schedaGuida(pagina, schedaCommessa);
  return id ? `${URL_CENTRO_ASSISTENZA}${id}.html` : URL_CENTRO_ASSISTENZA;
}

// La commessa aperta comunica la sua scheda attiva con questo evento (detail: id della scheda)
export const EVENTO_SCHEDA_COMMESSA = "nexiora:scheda-commessa";

/** Pagina dell'app che corrisponde a una scheda della guida (null se è una scheda della commessa o non ha pagina) */
export function paginaDiScheda(id) {
  const k = Object.keys(PER_PAGINA).find(p => PER_PAGINA[p] === id);
  return k || null;
}

/** Indirizzo dell'assistenza: per le domande a cui la guida non risponde */
export const EMAIL_ASSISTENZA = "support@nexiora.it";
